import { Button, ButtonProps, styled } from '@mui/material'
import {
  FOOTER_ACTION_BUTTON_HEIGHT,
  SEND_FIELD_BORDER_TOP_COLOR,
} from '$comp/_app/components/chat/components/conf'

const StyledButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: `${FOOTER_ACTION_BUTTON_HEIGHT}px`,
  minHeight: `${FOOTER_ACTION_BUTTON_HEIGHT}px`,
  backgroundColor: theme.palette.neutral000,
  borderRadius: 0,
  borderTop: `1px solid ${SEND_FIELD_BORDER_TOP_COLOR}`,
  ...theme.typography.subtitle3,
  '&:hover': {
    backgroundColor: theme.palette.neutral000,
  },
}))

export function ActionButton({
  alertMode,
  ...props
}: {
  alertMode?: boolean
} & ButtonProps) {
  return (
    <StyledButton
      {...props}
      sx={{ color: alertMode ? 'error.main' : 'secondary.main', ...props.sx }}
    />
  )
}

ActionButton.defaultProps = {
  alertMode: false,
}
